import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IDocument } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IDocument> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
